export default __webpack_public_path__ + "static/media/1005.87c3fb01.png";